!function () {
	'use strict';
	$(() => {
		const $advancedSearchContainer = $('.advanced-search-container');
		const $simpleTagsContainer = $('.simple-tags');
		if ($('input[name="search-type"][value="advanced"][checked]').length) {
			$simpleTagsContainer.hide();
			$advancedSearchContainer.show();
		}
		$('input[name="search-type"]').on('change', function () {
			if ($(this).val() === 'advanced') {
				$advancedSearchContainer.stop().slideDown();
				$simpleTagsContainer.stop().slideUp();
			} else {
				$advancedSearchContainer.stop().slideUp();
				$simpleTagsContainer.stop().slideDown();
			}
		});

		const $cityInfoContainer = $('.city-info-container');
		if ($('input[name="localization"][value="internet"][checked]').length) {
			$cityInfoContainer.hide();
		}
		$('input[name="localization"]').on('change', function () {
			if ($(this).val() === 'internet') {
				$cityInfoContainer.hide();
			} else {
				$cityInfoContainer.show();
			}
		});

	});
}();